var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"download-list"},_vm._l((_vm.accounts),function(account,index){return _c('ChildAccount',{key:index,attrs:{"account":account}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }